import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import UserValues from "./Features/userValues";
const reducer = combineReducers({
  UserValues,
});

const store = configureStore({
  reducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
